import axios from 'axios';

const store = {
  namespaced: true,
  state: {
    chats: [],
    outgoingFriendshipRequestsId: [],
    incomingFriendshipRequests: [],
    outgoingGroupRequestsId: [],
    dateSettings: {},
    currentUser: null,
    currentUserFriends: [],
    currentUserOnlineFriends: [],
    notificationsAmount: 0,
    unreadChatsCount: 0,
    loadingData: false
  },
  mutations: {
    setCurrentUser(state, data) {
      state.currentUser = data;
    },
    setChats(state, data) {
      state.chats = data;
    },
    setChat(state, data) {
      const index = state.chats.findIndex(x => x.id === data.id);
      state.chats = [...state.chats.slice(0, index), data, ...state.chats.slice(index + 1, state.chats.length)];
    },
    setOutgoingFriendshipRequestsId(state, data) {
      state.outgoingFriendshipRequestsId = data;
    },
    setIncomingFriendshipRequests(state, data) {
      state.incomingFriendshipRequests = data;
    },
    setOutgoingGroupRequestsId(state, data) {
      state.outgoingGroupRequestsId = data;
    },
    setDateSettings(state, data) {
      state.dateSettings = data;
    },
    setFriends(state, data) {
      state.currentUserFriends = data;
    },
    setOnlineFriends(state, data) {
      state.currentUserOnlineFriends = data;
    },
    setAvatarLastModified(state, data) {
      state.currentUser.avatarLastModified = data;
    },
    setNotificationsAmount(state, data) {
      state.notificationsAmount = data;
    },
    setUnreadChatsCount(state, data) {
      state.unreadChatsCount = data;
    },
    setLoading(state, value) {
      state.loadingData = value;
    }
  },
  actions: {
    getCache({ commit, dispatch }) {
      commit('setLoading', true);
      dispatch('getCurrentUser');
      dispatch('getChats');
      dispatch('getOutgoingGroupRequestsId');
      dispatch('getFriendshipInfo');
      dispatch('getNotificationsAmount');
      dispatch('loadUnreadChatsCount');
      // other caches
      commit('setLoading', false);
    },
    async loadUnreadChatsCount({ commit }) {
      const response = await axios.get('/conversation/unread/count');
      commit('setUnreadChatsCount', response.data);
    },
    async getNotificationsAmount({ commit }) {
      const notificationsAmount = (await axios.get('api/EventNotification/EventsAmount?showViewed=false')).data;
      commit('setNotificationsAmount', notificationsAmount);
    },
    async getChats({ commit }) {
      const conversations = (await axios.get('conversation/list')).data;
      commit('setChats', conversations);
    },
    async getOutgoingGroupRequestsId({ commit }) {
      const requests = (await axios.get('Group/GetOutgoingRequestsIds')).data;
      commit('setOutgoingGroupRequestsId', requests);
    },
    async getDateSettings({ commit }) {
      const dateSettings = (await axios.get('Common/GetDateSettings')).data;
      commit('setDateSettings', dateSettings);
    },
    async getCurrentUser({ commit }) {
      const currentUser = (await axios.get('Profile/GetCurrentUserProfile')).data;
      commit('setCurrentUser', currentUser);
    },
    async getFriendshipInfo({ commit }) {
      const friends = (await axios.get('Relationship/GetCurrentUserFriends')).data;
      commit('setFriends', friends);

      const outgoingRequestsIds = (await axios.get('Relationship/GetOutgoingRequestsId')).data;
      commit('setOutgoingFriendshipRequestsId', outgoingRequestsIds);

      const incomingRequests = (await axios.get('Relationship/GetIncomingRequests')).data;
      commit('setIncomingFriendshipRequests', incomingRequests);

      const onlineFriends = (await axios.get('Relationship/GetOnlineFriends')).data;
      commit('setOnlineFriends', onlineFriends);
    },
    setLoading({ commit }, value) {
      commit('setLoading', value);
    },
    refreshAvatar({ commit }) {
      commit('setAvatarLastModified', Date.now());
    }
  }
};

export default store;
